import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-body', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    margin: 0,
    overflow: 'hidden',
    display: 'none',
    '-webkit-overflow-scrolling': 'touch',
    fontFamily: 'Benton Sans, Arial, Helvetica, sans-serif',
    fontSize: '12px',
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    lineHeight: '1.5em',
});

